// Canonical namespace agent registry — single source of truth for @giveabit.io identities.
// Consumers: nostrData.js, scripts, EndpointStatus, verify-namespace.mjs
// Keep in sync with public/.well-known/nostr.json (NIP-05 names).

export const NAMESPACE_DOMAIN = 'giveabit.io'

/** Ordered list of live @giveabit.io identities */
export const NAMESPACE_AGENTS = [
  { local: 'cam', name: 'Cam', role: 'Founder', avatar: '/images/giveabit/agents/cam.jpg', signing: 'org-live' },
  { local: 'kimi', name: 'Kimi', role: 'Orchestrator', avatar: '/images/giveabit/kimi.jpg', signing: 'org-live' },
  { local: 'mimi', name: 'Mimi', role: 'Creative Director', avatar: '/images/giveabit/agents/mimi.jpg', signing: 'live' },
  { local: 'andrea', name: 'Andrea', role: 'Bitcoin Knowledge', avatar: '/images/giveabit/agents/andrea.png', signing: 'live' },
  { local: 'lenny', name: 'Lenny', role: 'Legal & Compliance', avatar: '/images/giveabit/agents/lenny.png', signing: 'live' },
  { local: 'rosa', name: 'Rosa', role: 'Chief Researcher', avatar: '/images/giveabit/agents/rosa.png', signing: 'live' },
  { local: 'sherpa', name: 'Sherpa', role: 'Product Guide · SherpaCarta', avatar: '/images/giveabit/agents/sherpa.png', signing: 'product-live' },
  { local: 'ziggy', name: 'Ziggy', role: 'DevOps Engineer', avatar: '/images/giveabit/agents/ziggy.png', signing: 'live' },
  { local: 'nova', name: 'Nova', role: 'Product Management', avatar: '/images/giveabit/agents/nova.png', signing: 'live' },
  { local: 'tina', name: 'Tina', role: 'Travel Concierge', avatar: '/images/giveabit/agents/tina.png', signing: 'live' },
  { local: 'hello', name: 'hello', role: 'Public Front Door', avatar: '/images/giveabit/agents/hello.png', signing: 'live' },
]

export const NAMESPACE_AGENT_LOCALS = NAMESPACE_AGENTS.map((a) => a.local)

export function nip05For(local) {
  return `${local}@${NAMESPACE_DOMAIN}`
}